import { render, staticRenderFns } from "./CreateGroupFooter.vue?vue&type=template&id=1906f019&scoped=true&"
import script from "./CreateGroupFooter.vue?vue&type=script&lang=ts&"
export * from "./CreateGroupFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGroupFooter.vue?vue&type=style&index=0&id=1906f019&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1906f019",
  null
  
)

export default component.exports